module.exports = __webpack_public_path__ + "static/media/Gratitude.9c43b4a1.jpg";